
import React from 'react';
import Category from './Category';
import DashboardLayout from '../../../components/Shop/StoreLayout/Layout/DashboardLayout';
import messages from '../../../locale/messages';

function action({ store, intl }) {
  const title = intl.formatMessage(messages.manageMenu);

  let isStoreAuthenticated = store.getState().runtime.isStoreAuthenticated;

  if (!isStoreAuthenticated) {
    return { redirect: '/store/login' };
  };

  return {
    title,
    component: (
      <DashboardLayout>
        <Category title={title} />
      </DashboardLayout>
    ),
  };
}

export default action;
